exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .not-existing-msg {\n    text-align: center;\n}\n.not-existing-img {\n    display: flex;\n    height: auto;\n}\n[dir] .not-existing-img {\n    margin: auto;\n    padding: 4rem 0;\n}", ""]);

